import { render, staticRenderFns } from "./TrafficMessageRow.vue?vue&type=template&id=2e307cdc"
import script from "./TrafficMessageRow.vue?vue&type=script&lang=js"
export * from "./TrafficMessageRow.vue?vue&type=script&lang=js"
import style0 from "./TrafficMessageRow.vue?vue&type=style&index=0&id=2e307cdc&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports